var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "typeAnswer", class: _vm.accordionClasses }, [
    _c(
      "div",
      {
        staticClass: "type-wrapper message-header",
        attrs: { tabindex: "0" },
        on: {
          click: _vm.toggleAnswer,
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.toggleAnswer.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              )
                return null
              return _vm.toggleAnswer.apply(null, arguments)
            },
          ],
        },
      },
      [_c("p", [_vm._v(" " + _vm._s(_vm.type.question) + " ")]), _vm._m(0)]
    ),
    _c("div", { staticClass: "type-wrapper message-body" }, [
      _c("p", { attrs: { tabindex: "0" } }, [
        _vm._v(" " + _vm._s(_vm.type.answer) + " "),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("i", { staticClass: "input-icon icon-chevron-up" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }